<div class="container-fluid h-100 p-2 p-sm-5">
    <div class="m-auto login-panel p-3 col-12 col-xl-4">

        <div class="row">
            <mat-form-field class="col">
                <input matInput placeholder="Email" [(ngModel)]="User.Email" (keyup.enter)="tryCredentials()" required>
            </mat-form-field>
        </div>
        <div *ngIf="!ShowResetForm" class="row">
            <mat-form-field class="col">
                <input matInput placeholder="Mot de passe" [(ngModel)]="User.Password"
                       (keyup.enter)="tryCredentials()" required [type]="IsPasswordVisible ? 'text' : 'password'">
                <mat-icon class="material-symbols-outlined" matSuffix (click)="$event.stopPropagation(); IsPasswordVisible = !IsPasswordVisible">
                    {{IsPasswordVisible ? 'visibility_off' : 'visibility'}}
                </mat-icon>
            </mat-form-field>
        </div>
        <div class="row mt-3 flex-column-reverse flex-md-row">
            <div *ngIf="!ShowResetForm" class="col-12 col-sm-6  my-2 my-sm-0">
                <button class="w-100" mat-raised-button color="primary" (click)="User.Email = ''; ShowResetForm = true">
                    Mot de passe oublié ?
                </button>
            </div>
            <div *ngIf="ShowResetForm" class="col-12 col-sm-6  my-2 my-sm-0">
                <button class="w-100" mat-raised-button color="primary" (click)="User.Email = ''; ShowResetForm = false">
                    Retour
                </button>
            </div>
            <div *ngIf="!ShowResetForm" class="col-12 col-sm-6  my-2 my-sm-0">
                <button class="w-100" mat-raised-button color="primary" (click)="tryCredentials()" [disabled]="!User.Email || !User.Password">
                    Se connecter
                </button>
            </div>
            <div *ngIf="ShowResetForm" class="col-12 col-sm-6 my-2 my-sm-0">
                <button class="w-100" mat-raised-button color="primary" (click)="resetPassword()" [disabled]="!User.Email">
                    Envoyer
                </button>
            </div>
        </div>
    </div>
</div>